import script from "./faqView.vue?vue&type=script&setup=true&lang=ts"
export * from "./faqView.vue?vue&type=script&setup=true&lang=ts"

import "./faqView.vue?vue&type=style&index=0&id=049d991c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049d991c"]])

export default __exports__